import { makeAutoObservable, runInAction } from 'mobx';
import { apiClient } from '../api/apiclient';
import { academyStore } from './AcademyStore';
export class ActivityStore {
    constructor() {
        this.activities = [];
        this.loading = false;
        this.error = null;
        this.selectedActivity = null;
        this.isDialogOpen = false;
        this.isEditing = false;
        makeAutoObservable(this);
    }
    // Actions
    async fetchActivities(academyId, filters) {
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.getActivitiesByAcademyId(academyId, filters);
            if (response.success) {
                runInAction(() => {
                    this.activities = response.data;
                    this.loading = false;
                });
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to fetch activities';
                this.loading = false;
            });
        }
    }
    async createActivity(activityData) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.createActivity(academyStore.currentAcademy.id, activityData);
            if (response.success) {
                runInAction(() => {
                    this.activities.unshift(response.data);
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to create activity';
                this.loading = false;
            });
            throw error;
        }
    }
    async updateActivity(id, activityData) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.updateActivity(academyStore.currentAcademy.id, id, activityData);
            if (response.success) {
                runInAction(() => {
                    const index = this.activities.findIndex(activity => activity.id === id);
                    if (index !== -1) {
                        this.activities[index] = response.data;
                    }
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to update activity';
                this.loading = false;
            });
            throw error;
        }
    }
    async deleteActivity(id) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.deleteActivity(academyStore.currentAcademy.id, id);
            if (response.success) {
                runInAction(() => {
                    this.activities = this.activities.filter(activity => activity.id !== id);
                    this.loading = false;
                });
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to delete activity';
                this.loading = false;
            });
            throw error;
        }
    }
    // Dialog actions
    openCreateDialog() {
        this.selectedActivity = null;
        this.isEditing = false;
        this.isDialogOpen = true;
    }
    openEditDialog(activity) {
        this.selectedActivity = activity;
        this.isEditing = true;
        this.isDialogOpen = true;
    }
    closeDialog() {
        this.isDialogOpen = false;
        this.selectedActivity = null;
        this.isEditing = false;
    }
    // Computed
    get hasActivities() {
        return this.activities.length > 0;
    }
    get isLoading() {
        return this.loading;
    }
    get hasError() {
        return this.error !== null;
    }
}
export const activityStore = new ActivityStore();
